module.exports = __webpack_public_path__ + "static/media/creator3.0a652df4.jpg";